// extracted by mini-css-extract-plugin
export default {"modal":"anyI7bQ09yy1Eiul3B36","backdrop":"OVsVzBJ3asz_T6wH40K9","open":"vjBQ7gX89kp2AI0ugwym","closeBtn":"tNhcFubqb_QEQQwZP1fN"};